import { fieldClasses } from '../ui/control.js'
/**
 * kind: time — the native time control.
 *
 * Its value is always 24-hour "HH:MM" regardless of how the phone chooses to
 * display it, which is exactly what we store. Native also means the participant
 * gets the picker they already know, at no build cost.
 */
export function TimeEntry({ item, format, answer, onChange, disabled, name }) {
  const value = typeof answer?.value === 'string' ? answer.value : ''

  return (
    <input
      id={name}
      name={name}
      type="time"
      // minutes, not seconds
      step={60}
      value={value}
      disabled={disabled}
      onChange={(e) => onChange({ ...answer, value: e.target.value || null })}
      className={'w-[8em] text-base tabular-nums ' + fieldClasses({})}
    />
  )
}
